import { render, staticRenderFns } from "./FormTemplatesPage.vue?vue&type=template&id=c1640266&"
import script from "./FormTemplatesPage.vue?vue&type=script&lang=js&"
export * from "./FormTemplatesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports